export enum SearchType {
    Property,
    Professional
}